// ---------------------------------------------------------------------------------------------------
export const defaultToolbarHeight = 26;
export function getToolbarHeight(height: number): number {
    return height > defaultToolbarHeight ? defaultToolbarHeight : defaultToolbarHeight / 2;
}
// ---------------------------------------------------------------------------------------------------